import React from 'react';

const ScoreSystemCard = ({ levelInfo, score }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">점수 시스템</h2>
          <p className="text-sm text-muted-foreground mt-1">현재 점수와 레벨 진행도를 확인하세요.</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-md bg-primary/20 text-primary flex items-center justify-center font-bold">
            Lv.{levelInfo?.level}
          </div>
          <div>
            <div className="text-sm text-muted-foreground caption">현재 점수</div>
            <div className="text-xl font-bold text-foreground data-text">{Number(score || 0).toLocaleString('ko-KR')}</div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-2">
          <span>{levelInfo?.current}점</span>
          <span>{levelInfo?.next}점</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-gaming rounded-full"
            style={{ width: `${levelInfo?.progress || 0}%` }}
          />
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 text-xs text-muted-foreground">
        <div className="px-3 py-2 rounded-md bg-muted/40 border border-border">목표 생성 +5</div>
        <div className="px-3 py-2 rounded-md bg-muted/40 border border-border">인증 업로드 +10</div>
        <div className="px-3 py-2 rounded-md bg-muted/40 border border-border">별점 4~5 보너스 +3</div>
        <div className="px-3 py-2 rounded-md bg-muted/40 border border-border">데드타임 기록 +2</div>
      </div>
    </div>
  );
};

export default ScoreSystemCard;
